import { t } from 'i18next';
import React, { useState } from 'react'

const PasswordInput = ({ placeholder = t('ENTER_PASSWORD'), onChange, name, value }) => {
    const [showPassword, setShowPassword] = useState(false);
    return (
        <div className='position-relative'>
            <input
                placeholder={placeholder}
                type={showPassword ? "text" : "password"}
                name={name}
                className="form-control"
                autoComplete='off'
                onChange={onChange}
                value={value}
            />
            <span
                style={{ top: '25%', right: '10px', position: 'absolute' }}
                type='button'
                onClick={() => setShowPassword(!showPassword)}
            >
                <i className={showPassword ? "fa-regular fa-eye-slash" : "fa-regular fa-eye"}></i>
            </span>
        </div>

    )
}

export default PasswordInput